import http from "@/http";

const route = "api/suporte";

export const suporteApi = {
  habilitado() {
    return http.get(`${route}/habilitado`);
  },

  analisar(payload) {
    return http.post(`${route}/analisar`, payload);
  },

  enviar(payload, arquivos) {
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    (arquivos || []).forEach((arquivo) => {
      formData.append("arquivos", arquivo);
    });

    return http.post(`${route}/enviar`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
